<template>
  <div>
    <b-input
      v-model="maskCredentials.maskName"
      :error-messages="getErrorMessages(v$.maskName)"
      label="Назва"
      placeholder="Наприклад: Маска вхідних документів"
      @blur="v$.maskName.$touch()"></b-input>
    <b-input
      v-model="maskCredentials.maskDescription"
      label="Опис"
      placeholder="Коротке пояснення призначення маски"></b-input>
    <b-input
      v-model="maskCredentials.numberMask"
      :error-messages="getErrorMessages(v$.numberMask)"
      label="Нумерація"
      placeholder="Наприклад: ВХ-%seq_number%/%yy%"
      @blur="v$.numberMask.$touch()"></b-input>
    <v-card
      :loading="$loading.isLoading('maskPlaceholders')"
      color="blue-grey-lighten-5">
      <v-card-text class="d-flex flex-column ga-1">
        <span class="font-size-11 font-weight-bold text-grey text-uppercase">
          Попередній перегляд
        </span>
        <span class="font-weight-bold font-size-15">{{
          previewMask || '---'
        }}</span>
      </v-card-text>
    </v-card>

    <div class="mt-5">
      <div class="d-flex align-center">
        <span class="font-weight-bold font-size-13">Змінні</span>
        <span class="text-disabled font-size-11">— натисніть для вставки</span>
      </div>

      <div class="mask-wrapper" style="max-height: 155px; overflow-y: auto">
        <div
          v-for="(mask, index) in $directory.get('maskPlaceholders')"
          :key="index"
          class="mask-block"
          @click="selectMask(mask)">
          <div class="d-flex align-center ga-1">
            <span class="font-weight-bold text-blue-darken-3">
              {{ mask.id }}
            </span>
            <span class="text-disabled text-lowercase">
              {{ mask.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, reactive } from 'vue'
import { required, useVuelidate } from '@/plugins'
import { fillDirectory, getDirectory } from '@/directory'
import { getErrorMessages } from '@/utils/helpers'
import { registrationJournalMaskCreate } from '@/requests/registrationJournal'

export default {
  name: 'MaskPlaceholder',
  props: {
    dialog: { type: Object, required: true },
  },
  methods: {
    getErrorMessages,
  },
  setup(props) {
    fillDirectory('maskPlaceholders')

    const maskCredentials = reactive({
      numberMask: '',
      maskName: null,
      maskDescription: null,
    })

    const previewMask = computed(() => {
      const masks = getDirectory('maskPlaceholders')

      let result = maskCredentials.numberMask

      masks.forEach(mask => {
        const preview =
          mask.id === '%j_code%' && props.dialog?.dialogData?.journalCode
            ? props.dialog.dialogData.journalCode
            : mask.preview
        const regex = new RegExp(mask.id.replace(/[%{}[\]]/g, '\\$&'), 'g')
        result = result.replace(regex, preview)
      })

      return result || '---'
    })

    const selectMask = (mask: { id: string | number }) => {
      maskCredentials.numberMask += mask.id
    }

    const v$ = useVuelidate(
      { numberMask: { required }, maskName: { required } },
      maskCredentials
    )

    const submit = () => {
      return registrationJournalMaskCreate(
        props.dialog.dialogData.journalId,
        maskCredentials
      ).then(res => {
        return res
      })
    }

    return {
      validationScope: 'maskPlaceholder',
      maskCredentials,
      selectMask,
      previewMask,
      submit,
      v$,
    }
  },
}
</script>

<style lang="scss" scoped>
.mask-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  padding: 6px 8px;
  border: 1px solid rgb(240, 240, 245);
  border-radius: 6px;
  background: rgb(255, 255, 255);
  cursor: pointer;
  text-align: left;
  transition: 0.12s;

  &:hover {
    border-color: #185fa5;
    background: #f5f8ff;
  }
}

.mask-wrapper {
  max-height: 200px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  padding: 2px;
}
</style>
